import { type CognitoRefreshResult, createCognitoService } from "./cognito-service";

export type CognitoRefreshOptions = {
  /** Регион Cognito User Pool, по умолчанию eu-central-1 */
  region?: string;
};

/**
 * Обновляет access token через AWS Cognito REFRESH_TOKEN_AUTH.
 * Бэкенд выдаёт те же Cognito-токены, переиспользуется в sbol, finuslugi и др.
 *
 * @param refreshToken — текущий refresh token (из cookie/store)
 * @param clientId — Cognito User Pool Web Client ID (например VITE_USER_POOL_WEB_CLIENT_ID)
 * @param options — опции (регион)
 * @returns новый idToken и при наличии новый refreshToken, иначе null
 */
export const refreshCognitoToken = async (
  refreshToken: string,
  clientId: string,
  options: CognitoRefreshOptions = {}
): Promise<CognitoRefreshResult | null> => {
  const cognito = createCognitoService({
    clientId,
    ...(options ? { options } : {}),
  });
  return await cognito.refreshToken(refreshToken);
};
